import { CommCodeModel, InputDeviceModel, OutputDeviceModel } from '@common/ProcessRegistration/model';
import api from './api';
import * as types from './mutation-types';

export default {
	fetchProcesses_: ({ state, commit }, payload) => {
		return api
			.fetchProcesses(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				const { pagingInfo, resultList } = body;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
					commit(types.DEFAULT_ASSIGN, { key: 'processes', value: resultList });
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPlants_: ({ state, commit }) => {
		return api
			.fetchPlants()
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const plants = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							plants
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchServiceKinds_: ({ state, commit }, payload) => {
		return api
			.fetchServiceKinds(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				console.warn('DBGDBG ServiceKind ===>', body);
				if (code === 0) {
					const serviceKinds = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							serviceKinds
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchProcTypes_: ({ state, commit }, payload) => {
		return api
			.fetchProcTypes(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const procTypes = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							procTypes
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchProcKinds_: ({ state, commit }, payload) => {
		return api
			.fetchProcKinds(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const procKinds = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							procKinds
						}
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	// fetchOutputDevices_: ({ state, commit }, payload) => {
	// 	return api.fetchOutputDevices(payload).then(data => {
	// 		const { header, body } = data;
	// 		const { code, message } = header;
	// 		const { resultList } = body;
	// 		if (code === 0) {
	// 			const outDevs = resultList.map(outDev => new OutputDeviceModel(outDev));
	// 			console.warn('DBGDBG ===> outDevs', outDevs);
	// 			commit(types.DEFAULT_ASSIGN, {
	// 				key: 'selectOptions',
	// 				value: {
	// 					...state.selectOptions,
	// 					outDevs
	// 				}
	// 			});
	// 		} else if (code === 3) {
	// 			throw new Error(message);
	// 		}
	// 		return header;
	// 	});
	// },

	// fetchInputDevices_: ({ state, commit }, payload) => {
	// 	return api.fetchInputDevices(payload).then(data => {
	// 		const { header, body } = data;
	// 		const { code, message } = header;
	// 		const { resultList } = body;
	// 		if (code === 0) {
	// 			const inDevs = resultList.map(inDev => new InputDeviceModel(inDev));
	// 			console.warn('DBGDBG ===> inDevs', inDevs);
	// 			commit(types.DEFAULT_ASSIGN, {
	// 				key: 'selectOptions',
	// 				value: {
	// 					...state.selectOptions,
	// 					inDevs
	// 				}
	// 			});
	// 		} else if (code === 3) {
	// 			throw new Error(message);
	// 		}
	// 		return header;
	// 	});
	// },

	createProcess_: ({ state, commit }, payload) => {
		return api
			.createProcess(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	updateProcess_: ({ state, commit }, payload) => {
		return api
			.updateProcess(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	deleteProcess_: ({ state, commit }, { process }) => {
		return api
			.deleteProcess(process)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	}
};
